/* eslint-disable jsx-a11y/anchor-is-valid */
import { CloudDownloadOutlined, SearchOutlined } from "@ant-design/icons";
import BoxContent from "@src/component/Desktop/content";
import { KEY, lang } from "@src/constants/common.const";
import TroubleIcon from "@src/styles/icon/trouble.svg";
import { Button, Checkbox, Col, DatePicker, Form, Row, Table } from "antd";
import moment from "moment";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { ReflexContainer, ReflexElement, ReflexSplitter } from "react-reflex";
import "react-reflex/styles.css";
import { useHistory } from "react-router-dom";
import { EquipmentApi } from "../../api/backend/equipment";
import Loading from "../../component/Desktop/loading/loading";
import { STYLE, TYPE_INPUT } from "../../constants/common.const";
import { handleCatchError, statusRes } from "../../constants/utils";
import EquipmentChart from "./equipmentChart";
import "./index.scss";

function getDistinctColor(index, total) {
  const hue = (index / total) * 360;
  return `hsl(${hue}, 70%, 50%)`;
}
function ChartItem({
  isEndUser,
  startDateChart,
  setStartDateChart,
  endDateChart,
  setEndDateChart,
  dataChart,
  setDataChart,
  isGetDataChart,
  setIsGetDataChart,
  activeTab,
  listSelectChart,
  setListSelectChart,
  generationNumber,
  machineCode,
  checkResultID,
  detailMachine,
  isFistCheck,
  setIsFirstCheck
}) {
  const dispatch = useDispatch();
  const history = useHistory();
  const [formSearch] = Form.useForm();
  const [loadingScreen, setLoadingScreen] = useState(false);
  const startRef = useRef();
  const endRef = useRef();
  const startError = !startDateChart && endDateChart;
  const endError = startDateChart && !endDateChart;
  const [endGetDataChart,setEndGetDataChart] = useState(false)

  // render dynamic chart
  const renderDynamicChart = () => {
    return (
      <EquipmentChart
        item={handleDataChart(dataChart)}
        isDynamicScreen={true}
        dataChartsLength={dataChart.length}
        isEndUser={isEndUser}
        isChartItem={true}
        machineName={
          detailMachine ? detailMachine.machineForSiteOfficeName : ""
        }
        machineCode={machineCode}
      />
    );
  };

  let allDates = [];
  if (
    dataChart &&
    Array.isArray(dataChart) &&
    dataChart.length > 0 &&
    Array.isArray(dataChart[0].data)
  ) {
    allDates = dataChart[0].data.map((d) => d.groupTitle) || [];
  }

  // Build columns
  const columns = [
    {
      title: "点検項目",
      dataIndex: "title",
      key: "title",
      align: "center",
      width: 200,
      fixed: "left",
    },
    {
      title: "単位",
      dataIndex: "unit",
      key: "unit",
      align: "center",
      width: 80,
      fixed: "left",
    },
    {
      title: "グラフ化",
      width: 80,
      key: "checkbox",
      dataIndex: "checkbox",
      align: "center",
      fixed: "left",
      render: (isCheckbox, row) => {
        if (isCheckbox) {
          return (
            <Checkbox
              onChange={() => {
                if (listSelectChart.includes(row.checkItemCode)) {
                  setListSelectChart(
                    [...listSelectChart].filter((i) => i != row.checkItemCode)
                  );
                } else {
                  setListSelectChart([...listSelectChart, row.checkItemCode]);
                }
              }}
              checked={listSelectChart.includes(row.checkItemCode)}
            />
          );
        } else {
          return null;
        }
      },
    },
    ...allDates.map((date) => ({
      title: date.split("T")[0],
      dataIndex: date,
      width: 200,
      key: date,
      align: "center",
    })),
  ];

  // Build dataSource
  const dataSource = useMemo(() => {
    return dataChart.map((item, idx) => {
      const row = {
        key: idx + 1,
        title: item.title,
        unit: item.unit,
        checkItemCode: item.checkItemCode,
      };
      item.data.forEach((d) => {
        row[d.groupTitle] = d.value;
      });
      row["checkbox"] = item.mode === TYPE_INPUT.NUMBER;
      return row;
    });
  }, [dataChart]);

  useEffect(() => {
    if (!isFistCheck && dataSource && dataSource.length > 0) {
      const arrCheck = [];
  
      dataSource.forEach((item) => {
        if (item.checkbox && arrCheck.length === 0) {
          arrCheck.push(item.checkItemCode);
        }
      });
  
      if (arrCheck.length > 0) {
        setListSelectChart((prev) => [...new Set([...prev, ...arrCheck])]);
      }
  
      setIsFirstCheck(true);
    }
  }, [dataSource, isFistCheck]);
  // Serach chart
  const searchDataChart = async () => {
    // validate serarch
    if (startDateChart && !endDateChart) {
      endRef.current.focus();
      return;
    }
    if (!startDateChart && endDateChart) {
      startRef.current.focus();
      return;
    }
    try {
      setLoadingScreen(true);
      const res = await EquipmentApi.getDataChart({
        machineCode,
        startDate: startDateChart
          ? moment(startDateChart).format(KEY.DATE_DEFAULT)
          : "",
        endDate: endDateChart
          ? moment(endDateChart).format(KEY.DATE_DEFAULT)
          : "",
        generationNumber,
      });
      const data = res.data;
      setDataChart(data);
      setIsGetDataChart(true);
      setEndGetDataChart(true)
    } catch (error) {
      handleCatchError(error);
    } finally {
      setLoadingScreen(false);
    }
  };

  // Download Data
  const dowloadData = () => {
    const params = {
      machineCode,
      startDateString: startDateChart
        ? moment(startDateChart).format("YYYY-MM-DD")
        : "",
      endDateString: endDateChart
        ? moment(endDateChart).format("YYYY-MM-DD")
        : "",
    };
    setLoadingScreen(true);

    EquipmentApi.dowloadDataChart(params)
      .then((res) => {
        if (statusRes(res)) {
          const blob = new Blob([res.data]);
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.target = "_blank";
          const fileName = machineCode + "_" + (detailMachine ? detailMachine.machineForSiteOfficeName : "");
          link.download = fileName + ".xlsx";
          link.click();
        }
      })
      .catch((err) => {
        console.log(err);
        handleCatchError(err);
      })
      .finally(() => {
        setLoadingScreen(false);
      });
  };
  useEffect(() => {
    if (activeTab == 7 && !isGetDataChart && machineCode) {
      searchDataChart();
    }
    if(isGetDataChart){
      setEndGetDataChart(true)
    }
  }, [activeTab, isGetDataChart, generationNumber, machineCode]);

  const handleDataChart = (itemUpdate) => {
    const itemUpdated = itemUpdate;
    const dataChart = itemUpdate;
    const arrLabels = [];
    const arrData = [];
    let hasDataLabel = false;
    dataChart.forEach((line, index) => {
      // handle line data
      const arrLineValue = [];
      let hasDataValue = false;
      if (line.data.length) {
        const dataLine = line.data;
        dataLine.forEach((itemDayOfLine) => {
          if (!hasDataLabel) {
            let label;
            if (itemDayOfLine.groupTitle) {
              label = itemDayOfLine.groupTitle;
            } else {
              label = itemDayOfLine.title || "";
            }
            arrLabels.push(label);
          }
          if (itemDayOfLine.value !== null) {
            hasDataValue = true;
          }
          const finalValue =
            itemDayOfLine.value == 0 ? 0 : Number(itemDayOfLine.value) || null;
          arrLineValue.push(finalValue);
        });
        hasDataLabel = true;
      }
      const lineData = {
        name: line.checkItemName || line.title,
        data: hasDataValue ? arrLineValue : [],
        machineName: line.machineForSiteOfficeName || "",
        color: getDistinctColor(index, dataChart.length),
        unit: line.unit,
        min: line.min,
        max: line.max,
        normalLowerControlValue: line.normalLowerControlValue,
        normalUpperControlValue: line.normalUpperControlValue,
        itemCode: line.checkItemCode,
      };
      arrData.push(lineData);
    });

    let isHasData = false;
    for (let i = 0; i < arrData.length; i++) {
      if (arrData[i].data.length) {
        isHasData = true;
        break;
      }
    }
    let machineForSiteOfficeName = "";
    if (dataChart && dataChart[0] && dataChart[0].machineForSiteOfficeName) {
      machineForSiteOfficeName = dataChart[0].machineForSiteOfficeName;
    }
    const dataItem = {
      id: itemUpdated.id,
      itemCode: itemUpdated.checkItemCode,
      checkItemName: "",
      labels: arrLabels,
      type: itemUpdated.type,
      machineName: machineForSiteOfficeName || "",
      normalLowerControlValue: itemUpdated.normalLowerControlValue,
      normalUpperControlValue: itemUpdated.normalUpperControlValue,
      // min: itemUpdate.min,
      // max: itemUpdate.max,
      unit: itemUpdated.unit,
      series: arrData.filter((i) => listSelectChart.includes(i.itemCode)),
      categories: arrLabels,
      isHasData: isHasData,
      reportName: itemUpdated.name,
      checklistType: itemUpdated.checklistType,
    };
    return dataItem;
  };

  const handleLinktoChecklistResult = () => {
    if (
      checkResultID !== "" &&
      checkResultID !== null &&
      checkResultID !== undefined
    ) {
      window.open("/history-detail/" + checkResultID, "_blank");
    }
  };

  const [perVertical,setPerVertical] = useState(0.4)
useEffect(() => {
  if(endGetDataChart){
    setTimeout(() => {
      let h1,h2;
      const el = document.getElementById("section-chart-machine-id");
      if (el) {
        h1 = el.offsetHeight;
      } 
      const el2 = document.getElementById("section-chart-machine-wrap-id");
      if (el2) {
        h2 = el2.offsetHeight;
      } 
      if(h1 > 0 && h2 > 0){
        const per = (h1 + 110)/h2;
        setPerVertical(1-per)  
      }
    }, 100); 
  }
  
},[endGetDataChart])
  return (
    <div id="section-chart-machine-wrap-id">
      <Form className="formSearchTemp" name="templateSearch" form={formSearch}>
        <ReflexContainer
          orientation="horizontal"
          style={{ height: "calc(100vh - 120px)" }}
        >
          <ReflexElement flex={perVertical} minSize={0} maxSize={window.innerHeight}>
            {!isEndUser && (
              <div>
                <Row className="rowNotMargin" align="bottom" gutter={8}>
                  <Col md={3} span={24}>
                    <Row className="rowNotMargin">
                      <Col span={24} className="title-form-item">
                        開始日
                      </Col>
                      <Col span={24}>
                        <DatePicker
                          format={KEY.DATE_DEFAULT}
                          ref={startRef}
                          value={startDateChart}
                          onChange={(v) => setStartDateChart(v)}
                          placeholder={"開始日"}
                          className={`${
                            startError ? STYLE.BORDER_RED : ""
                          } w100`}
                          disabledDate={(current) =>
                            endDateChart
                              ? current && current > endDateChart.endOf("day")
                              : false
                          }
                        />
                      </Col>
                    </Row>
                  </Col>
                  <span style={{ fontSize: "20px" }}>~</span>

                  <Col md={3} span={24}>
                    <Row className="rowNotMargin">
                      <Col span={24} className="title-form-item">
                        終了日
                      </Col>
                      <Col span={24}>
                        <DatePicker
                          format={KEY.DATE_DEFAULT}
                          ref={endRef}
                          value={endDateChart}
                          onChange={(v) => setEndDateChart(v)}
                          placeholder={"終了日"}
                          className={`${endError ? STYLE.BORDER_RED : ""} w100`}
                          disabledDate={(current) =>
                            startDateChart
                              ? current &&
                                current < startDateChart.startOf("day")
                              : false
                          }
                        />
                      </Col>
                    </Row>
                  </Col>
                  <Col md={16} span={24}>
                    <Row className="rowNotMargin" align="middle">
                      <Col>
                        <Button
                          disabled={!machineCode}
                          onClick={searchDataChart}
                          className="buttonPC button--info"
                          icon={<SearchOutlined />}
                        >
                          {lang.SEARCH}
                        </Button>
                      </Col>
                      <Col style={{ paddingLeft: "12px" }}>
                        <Button
                          disabled={
                            !machineCode ||
                            !dataChart ||
                            !Array.isArray(dataChart) ||
                            dataChart.length === 0
                          }
                          onClick={dowloadData}
                          className="buttonPC button--outline --todo--"
                        >
                          <CloudDownloadOutlined style={{ color: "#f50" }} />
                          {lang.EXPORT}
                        </Button>
                      </Col>
                      <Col style={{ paddingLeft: "12px" }}>
                        <Button
                          disabled={
                            checkResultID === "" ||
                            checkResultID === null ||
                            checkResultID === undefined
                          }
                          onClick={() => handleLinktoChecklistResult()}
                          className="buttonPC button--outline --todo--"
                        >
                          最新の点検結果へ
                        </Button>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Table
                  style={{
                    marginTop: 20,
                  }}
                  dataSource={dataSource}
                  columns={columns}
                  className="gridSingle2"
                  pagination={false}
                  scroll={{
                    x:
                      columns.length > 9
                        ? 120 + 80 + allDates.length * 110
                        : undefined,
                    y: dataSource.length > 5 ? 425 : undefined,
                  }}
                />
              </div>
            )}
          </ReflexElement>
          <ReflexSplitter propagate={true} />

          <ReflexElement minSize={0} maxSize={window.innerHeight}>
            <BoxContent>
              <Row id="section-chart-machine-id" className="rowNotMargin" gutter={[12, 12]}>
                {!isEndUser && (
                  <Col span={24}>
                    <Row
                      className="rowNotMargin"
                      align="middle"
                      justify="space-between"
                    ></Row>
                  </Col>
                )}
                <Col span={24}>
                  <Row
                    id="parent-chart"
                    className="rowNotMargin"
                    align="center"
                  >
                    {renderDynamicChart()}
                  </Row>
                </Col>
              </Row>
            </BoxContent>
          </ReflexElement>
        </ReflexContainer>

        <Loading show={loadingScreen} />
      </Form>

      <Loading show={loadingScreen} />
    </div>
  );
}

export default ChartItem;
